module.exports = __webpack_public_path__ + "static/media/thirteen.2ddd62c4.jpg";